import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const LoginForm = ({
  formData,
  errors,
  isLoading,
  showPassword,
  onInputChange,
  onTogglePassword,
  onSubmit
}) => {
  return (
    <form onSubmit={onSubmit} className="space-y-5">
      <Input
        type="email"
        label="Email Address"
        placeholder="you@example.com"
        value={formData?.email}
        onChange={(e) => onInputChange('email', e?.target?.value)}
        error={errors?.email}
        required
        disabled={isLoading}
        className="w-full"
      />
      <div className="space-y-2">
        <div className="relative">
          <Input
            type={showPassword ? 'text' : 'password'}
            label="Password"
            placeholder="Enter your password"
            value={formData?.password}
            onChange={(e) => onInputChange('password', e?.target?.value)}
            error={errors?.password}
            required
            disabled={isLoading}
            className="w-full pr-12"
          />
          <button
            type="button"
            onClick={onTogglePassword}
            className="absolute right-3 top-[38px] text-gray-400 hover:text-gray-600 transition-colors p-1 rounded hover:bg-gray-100"
            disabled={isLoading}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            <Icon name={showPassword ? 'EyeOff' : 'Eye'} size={18} />
          </button>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <Checkbox
          label="Remember me"
          checked={formData?.rememberMe}
          onChange={(e) => onInputChange('rememberMe', e?.target?.checked)}
          disabled={isLoading}
        />
        <button
          type="button"
          className="text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors hover:underline"
          disabled={isLoading}
        >
          Forgot Password?
        </button>
      </div>
      <Button
        type="submit"
        variant="default"
        size="lg"
        fullWidth
        loading={isLoading}
        iconName="LogIn"
        iconPosition="right"
        className="mt-6"
      >
        {isLoading ? 'Signing In...' : 'Sign In'}
      </Button>
    </form>
  );
};

export default LoginForm;